import React, { Component } from 'react';
import Dialog from '../Dialog/index';
import { translations } from 'i18n';
import { triggerAppSync, triggerWifiConnect } from 'actions/gallery';
import { triggerContinueInstall } from 'actions/install-flow';
import { ContinueInstallType, TriggerSyncType } from './index'

type ReduxProps = ReturnType<typeof stateToProps>;

export const stateToProps = (
  { continueInstall, requiresWifi }:
  { continueInstall: ContinueInstallType, requiresWifi: boolean}
) => ({
    installFlow: {
      requiresWifi
    },
    continueInstall: {
      show: continueInstall.show && !continueInstall.hasBeenSeen
    }
});

export const dispatchToProps = (dispatch: any) => ({
  async triggerSync(installFlow: TriggerSyncType) {
    await dispatch(
      triggerContinueInstall({
        show: false,
        hasBeenSeen: true,
        shouldContinue: true
      })
    );

    if (installFlow.requiresWifi) {
      try {
        await dispatch(triggerWifiConnect());
      } catch (error) {
        return;
      }
    }

    return dispatch(triggerAppSync({ requiresWifi: installFlow.requiresWifi }));
  },
  // TODO Originally planned to removed in progress apps when user cancels
  // but with most apps being required the logic would not work well
  async triggerRemove() {
    await dispatch(
      triggerContinueInstall({
        show: false,
        hasBeenSeen: true,
        shouldContinue: false
      })
    );
  }
});

interface ContinueInstallModalProps extends ReduxProps {
  triggerSync: (args: TriggerSyncType) => void
  triggerRemove: () => void
}

export default class ContinueInstallModal extends Component<ContinueInstallModalProps> {
  sync = () => {
    this.props.triggerSync(this.props.installFlow);
  };

  remove = () => {
    this.props.triggerRemove();
  };

  render() {
    const {
      component: {
        ContinueInstallModal: {
          title,
          text,
          continueButtonText,
          cancelButtonText
        }
      }
    } = translations;
    return (
      <Dialog
        show={true}
        id="ContinueInstallModal"
        title={title()}
        message={text()}
        onDismiss={this.remove}
        actions={[
          {
            text: cancelButtonText(),
            id: 'cancel-wait-button',
            onClick: this.remove,
            variant: 'text'
          },
          {
            text: continueButtonText(),
            id: 'ok-wait-button',
            onClick: this.sync,
            variant: 'filled'
          }
        ]}
      />
    );
  }
}
